import { render, staticRenderFns } from "./salesreceipts.vue?vue&type=template&id=6673d700&"
import script from "./salesreceipts.vue?vue&type=script&lang=js&"
export * from "./salesreceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports